import { getGlobalCssUrl, getComponentCssUrl } from '../Global/loadDependency'

function createNavHeaderLevel1Template() {
  const t = document.createElement('template')
  t.innerHTML = `
<link href="${getGlobalCssUrl('trustage-aa--wc.css')}" rel="stylesheet" />
<link href="${getComponentCssUrl('NavHeader-Level1--wc.css')}" rel="stylesheet" />
`
  return t
}

const getTemplateNavHeaderStyles = () => createNavHeaderLevel1Template()
export { getTemplateNavHeaderStyles }
